import styled from "styled-components";

import { Banner } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

export const BannerContainer = styled(Banner)<{ $background: string }>`
    background-color: ${({ $background }) => $background};
`;

export const BannerContent = styled(Flex)`
    align-items: center;
    gap: 6px;
`;
